import {
  Users,
  FileText,
  Calendar,
  MessageSquare,
  BarChart3,
  Settings,
  Phone,
  Mail,
  FileSpreadsheet,
  DollarSign,
  Clock,
  Target,
} from "lucide-react";

export const teamCapabilities = [
  {
    id: "lead_management",
    label: "Lead Management",
    shortLabel: "Lead Mgmt",
    icon: Users,
    color: "#6366f1",
    category: "sales_data",
  },
  {
    id: "reporting",
    label: "Reporting",
    shortLabel: "Reporting",
    icon: BarChart3,
    color: "#8b5cf6",
    category: "sales_data",
  },
  {
    id: "data_export",
    label: "Data Export",
    shortLabel: "Data Export",
    icon: FileSpreadsheet,
    color: "#14b8a6",
    category: "sales_data",
  },
  {
    id: "payment_tracking",
    label: "Payment Tracking",
    shortLabel: "Payments",
    icon: DollarSign,
    color: "#84cc16",
    category: "sales_data",
  },
  {
    id: "calling",
    label: "Calling",
    shortLabel: "Calling",
    icon: Phone,
    color: "#10b981",
    category: "communication",
  },
  {
    id: "messaging",
    label: "Messaging",
    shortLabel: "Messaging",
    icon: MessageSquare,
    color: "#f59e0b",
    category: "communication",
  },
  {
    id: "email",
    label: "Email",
    shortLabel: "Email",
    icon: Mail,
    color: "#3b82f6",
    category: "communication",
  },
  {
    id: "scheduling",
    label: "Scheduling",
    shortLabel: "Scheduling",
    icon: Calendar,
    color: "#ec4899",
    category: "communication",
  },
  {
    id: "task_management",
    label: "Task Management",
    shortLabel: "Tasks",
    icon: Clock,
    color: "#f97316",
    category: "operations",
  },
  {
    id: "documentation",
    label: "Documentation",
    shortLabel: "Docs",
    icon: FileText,
    color: "#06b6d4",
    category: "operations",
  },
  {
    id: "settings_access",
    label: "Settings Access",
    shortLabel: "Settings",
    icon: Settings,
    color: "#64748b",
    category: "operations",
  },
  {
    id: "target_setting",
    label: "Target Setting",
    shortLabel: "Targets",
    icon: Target,
    color: "#ef4444",
    category: "operations",
  },
];

export const capabilityCategories = [
  { id: "sales_data", label: "Sales & Data" },
  { id: "communication", label: "Communication" },
  { id: "operations", label: "Operations" },
];
